import {
  Injectable,
  inject,
  EnvironmentInjector,
  runInInjectionContext,
} from "@angular/core";
import { Database, ref, runTransaction } from "@angular/fire/database";
import { UtilService } from "./util.service";
@Injectable()
export class AppStatsService {
  private readonly mdb = inject(Database);
  private readonly injector = inject(EnvironmentInjector);
  constructor(public util: UtilService) {}

  private tx(path: string, fn: (current: any) => any) {
    return runInInjectionContext(this.injector, () =>
      runTransaction(ref(this.mdb, path), fn)
    );
  }

  signup() {
    let dayDate = this.util.shedTime(Date.now());
    this.tx("globals/profileCount", (count) => count + 1);
    this.tx("globals/signups/" + dayDate, (count) => (count ? count + 1 : 1));
  }
  updateLocationStats(locObject: any) {
    let dayDate = this.util.shedTime(Date.now());
    if (locObject && locObject.country) {
      this.tx("globals/countries/" + locObject.country, (count) =>
        count ? count + 1 : 1
      );
      this.tx(
        "globals/countryProfiles/" + locObject.country + "/" + dayDate,
        (count) => (count ? count + 1 : 1)
      );
    }
    if (locObject && locObject.continent) {
      this.tx("globals/continents/" + locObject.continent, (count) =>
        count ? count + 1 : 1
      );
    }
  }
}
